import { Fragment, useEffect } from "react";

import "./styles/colors.css";
import "./styles/fonts.css";
import "./styles/index.css";
import "./styles/transitions.css";

import { useTranslation } from "react-i18next";
import {
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import { ROUTES } from "@/routing";
import { manageCacheAndVersion } from "@/utils/cacheAndVersion";

import LanguageRoute from "./components/LanguageRoute";
import DefaultLayout from "./layouts/DefaultLayout";
import NotFound from "./pages/404";

const AppLayout = () => {
  return (
    <div id="ford-lasso" className={`flex flex-col font-ford bg-[#FFF]`}>
      <Outlet />
    </div>
  );
};

const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  // Run cache and version management on mount
  useEffect(() => {
    manageCacheAndVersion();
  }, []);

  // Generate routes for a specific language
  const generateLanguageRoutes = () => {
    return Object.entries(ROUTES).flatMap(([key, config]) => {
      const Layout = config.layout;
      const Component = config.component;
      return ["en", "fr"].map((language) => {
        const child = (
          <LanguageRoute>
            <Layout>
              <Component />
            </Layout>
          </LanguageRoute>
        );

        return (
          <Fragment key={`${language}-${key}`}>
            <Route path={config.default} element={child} />
            <Route
              path={config[language as keyof typeof config] as string}
              element={child}
            />
          </Fragment>
        );
      });
    });
  };

  return (
    <Router>
      <Routes>
        <Route element={<AppLayout />}>
          {generateLanguageRoutes()}

          <Route
            key="not-found"
            path="*"
            element={
              <DefaultLayout>
                <NotFound />
              </DefaultLayout>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
